import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { createShift } from "adminApi/DutyRosterApi/ShiftApi";
import { ShiftRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import AddShiftForm from "./Componates/AddShiftForm";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import { validateForm } from "utils/validation";
import fields from "../json/ShiftFields.json";

const AddShift = () => {
  const navigate = useNavigate();
  const { formFields } = fields

  // Build initial values object from fields
  const initialValues = formFields.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

  const { values, errors, handleChange, setValues, setErrors } = useFormChange(initialValues, ShiftRules);

  useEffect(() => {
    if (values.start_time && values.end_time) {
      const [startH, startM, startS] = values.start_time.split(':').map(Number);
      const [endH, endM, endS] = values.end_time.split(':').map(Number);

      const startDate = new Date();
      startDate.setHours(startH || 0, startM || 0, startS || 0, 0);

      const endDate = new Date();
      endDate.setHours(endH || 0, endM || 0, endS || 0, 0);

      // If end time is before start time, assume shift ends the next day
      if (endDate < startDate) {
        endDate.setDate(endDate.getDate() + 1);
      }

      const diffMs = endDate - startDate;
      const diffMinutes = diffMs / (1000 * 60);
      const diffHrs = diffMs / (1000 * 60 * 60);
      const shiftHours = parseFloat(diffHrs.toFixed(2));

      // Validate minimum 30 minutes gap
      if (diffMinutes < 30) {
        setErrors((prev) => ({
          ...prev,
          end_time: "End time must be at least 30 minutes after start time"
        }));
      } else {
        // Clear the error if valid
        setErrors((prev) => {
          const { end_time, ...rest } = prev;
          return rest;
        });
      }

      if (values.shift_hours !== shiftHours) {
        setValues((prev) => ({ ...prev, shift_hours: shiftHours }));
      }
    } else {
      if (values.shift_hours !== "") {
        setValues((prev) => ({ ...prev, shift_hours: "" }));
      }
    }
  }, [values.start_time, values.end_time, values.shift_hours, setValues, setErrors]);

  const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
    async (formValues) => {
      const formData = new FormData();
      Object.entries(formValues).forEach(([key, val]) => formData.append(key, val ?? ""));
      return await createShift({ data: formData });
    },
    (vals) => {
      const err = validateForm(vals, ShiftRules);
      // Check for time gap error in current errors state
      if (errors.end_time) {
        err.end_time = errors.end_time;
      }
      setErrors(err);
      return err;
    },
    () => navigate(-1),
    "Shift Created Successfully"
  );

  return (
    <>
      {loadingSubmit && <Spinner isSpinner={true} />}
      <AddShiftForm
        fields={formFields}
        values={values}
        errors={errors}
        handleChange={handleChange}
        handleSubmit={(e) => handleSubmit(e, values)}
        loading={loadingSubmit}
      />
    </>
  );
};

export default AddShift;
